// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_content_delivery_bucket": "dev.countmein.net.au",
    "aws_content_delivery_bucket_region": "ap-southeast-2",
    "aws_content_delivery_url": "http://dev.countmein.net.au.s3-website-ap-southeast-2.amazonaws.com",
    "aws_cognito_identity_pool_id": "ap-southeast-2:3476c38d-7b17-414e-97c3-3c226d275c8d",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_5q0Jls3dQ",
    "aws_user_pools_web_client_id": "3l2qip127hptp5g04bue0o5raa",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://yaakqlwomzfqlfvymnfzxfl5wi.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "cmiLoginByCode",
            "endpoint": "https://rp99o6i5h7.execute-api.ap-southeast-2.amazonaws.com/dev",
            "region": "ap-southeast-2"
        }
    ],
    "aws_user_files_s3_bucket": "countmein-assets-dev",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};


export default awsmobile;
